<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>     
        <div class="text-left">
            <h1>February 3</h1>
            <p>Breakfast at Dundee.</p>
            <img alt="Breakfast at Dundee" class="uitk-image-media" src="/uk/03Breakfast.jpeg" style="width: 17%; height: auto;">                
        </div>                  
      <v-row>
        <v-col cols="12" class="text-left">
          <div class="text-left">
              <p>The search for the Loch Ness monster begins.</p>
              <img alt="Loch Ness" class="uitk-image-media" src="/uk/03Lochness.jpeg" style="width: 17%; height: auto;">                
              <img alt="Loch Ness" class="uitk-image-media" src="/uk/03Lochness2.jpeg" style="width: 17%; height: auto;">                
              <p>These are photos but nothing found.</p>
            </div>      
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-left">
          <div class="text-left">
              <p>The search for Whisky begins.</p>
              <img alt="Whisky Tanker" class="uitk-image-media" src="/uk/03WhiskyTanker.jpeg" style="width: 17%; height: auto;">                
              <img alt="Malt truck" class="uitk-image-media" src="/uk/03Malt.jpeg" style="width: 17%; height: auto;">                
              <p>Malt and Whisky trucks located.</p>
            </div>      
        </v-col>
      </v-row>  
      <v-row>
        <v-col cols="12" class="text-left">
          <div class="text-left">
            <p>Scotland</p>
            <img alt="Whisky Tanker" class="uitk-image-media" src="/uk/03Scotland.jpeg" style="width: 17%; height: auto;">                
          </div>      
        </v-col>
      </v-row>               
      <v-row>
        <v-col cols="12" class="text-left">
          <div class="text-left">
            <p>Heavy rain warning and darkness lead to the decision to locate closest accomodation eventually.</p>
            <img alt="Knpoch" class="uitk-image-media" src="/uk/03Knipoch.png" style="width: 17%; height: auto;">                
          </div>      
        </v-col>
      </v-row>   
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>